import PackageStructure from './PackageStructure';
import type { PackageStructureProps } from './PackageStructure';

const SimulationTabContent = ({
    packages,
    expandedPackages,
    expandedTiers,
    onTogglePackage,
    onToggleTier,
    isVisible,
    onToggleVisibility,
    selectedPeriod,
    onPeriodChange,
}: PackageStructureProps) => {
    return (
        <div className="bg-default rounded-4 p-24">
            <PackageStructure
                packages={packages}
                expandedPackages={expandedPackages}
                expandedTiers={expandedTiers}
                onTogglePackage={onTogglePackage}
                onToggleTier={onToggleTier}
                isVisible={isVisible}
                onToggleVisibility={onToggleVisibility}
                selectedPeriod={selectedPeriod}
                onPeriodChange={onPeriodChange}
            />
        </div>
    );
};

export default SimulationTabContent;
